const logResData = (resData, action) => {
  try {
    // console.log(`${action}: FROM TRY`, JSON.stringify(resData));
  } catch (ex) {
    console.log(`${action}: FROM CATCH`, resData);
  }
};

export { logResData };
